export default __webpack_public_path__ + "static/media/B15.973dcba7.png";